import { render, staticRenderFns } from "./PlayerRegistrationForm.vue?vue&type=template&id=8a5fc1d6&scoped=true&"
import script from "./PlayerRegistrationForm.vue?vue&type=script&lang=js&"
export * from "./PlayerRegistrationForm.vue?vue&type=script&lang=js&"
import style0 from "./PlayerRegistrationForm.vue?vue&type=style&index=0&id=8a5fc1d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a5fc1d6",
  null
  
)

export default component.exports